import { AnswerStatus } from "@/models/enum/answerStatus";
import { ForwardingStatus } from "@/models/enum/forwardingStatus";

export type QuestionnaireStatus = AnswerStatus | ForwardingStatus;

export function getQuestionnaireStatusColor(
  status: ForwardingStatus | AnswerStatus
) {
  if (
    status == ForwardingStatus.Completed ||
    status == AnswerStatus.Completed
  ) {
    return "var(--dark-status-green)";
  } else if (status == AnswerStatus.InProgress) {
    return "var(--status-blue)";
  } else if (
    status == AnswerStatus.NotStarted ||
    status == ForwardingStatus.NotStarted
  ) {
    return "var(--status-orange-yellow)";
  } else if (
    status == AnswerStatus.NotRegistered ||
    status == ForwardingStatus.Pending
  ) {
    return "var(--status-grey)";
  } else if (status == ForwardingStatus.NotApplicable) {
    return "var(--violet)";
  }
}

export function getQuestionnaireStatusTextColor(
  status: ForwardingStatus | AnswerStatus
) {
  if (
    status == ForwardingStatus.Completed ||
    status == AnswerStatus.Completed
  ) {
    return "white";
  } else if (status == AnswerStatus.InProgress) {
    return "white";
  } else if (
    status == AnswerStatus.NotStarted ||
    status == ForwardingStatus.NotStarted
  ) {
    return "black";
  } else if (
    status == AnswerStatus.NotRegistered ||
    status == ForwardingStatus.Pending
  ) {
    return "black";
  } else if (status == ForwardingStatus.NotApplicable) {
    return "white";
  }
}

export function questionnaireStatusToDisplayText(
  status: ForwardingStatus | AnswerStatus
) {
  if (
    status == ForwardingStatus.Completed ||
    status == AnswerStatus.Completed
  ) {
    return "Completed";
  } else if (status == AnswerStatus.InProgress) {
    return "In progress";
  } else if (
    status == AnswerStatus.NotStarted ||
    status == ForwardingStatus.NotStarted
  ) {
    return "Not started";
  } else if (
    status == AnswerStatus.NotRegistered ||
    status == ForwardingStatus.Pending
  ) {
    return "Pending";
  } else if (status == ForwardingStatus.NotApplicable) {
    return "N/A";
  }
}
